<template>
  <div v-if="isExtension" class="flex items-center gap-2">
    <div >
      <img v-if="partner === WhiteLabelPartnerEnum.BAYZAT" src="../../assets/logos/bayzat-wc.png" class="h-16" alt="bayzat ats logo">
      <img v-else src="../../assets/logos/wc-logo.png" class="h-16" alt="whitecarrot ats logo">
    </div>
    <h1 class="text-base sm:text-xl md:text-2xl text-wcTextColor">{{text}}</h1>
  </div>
  <div v-else class="flex flex-col flex-wrap items-center gap-y-6">
    <div>
      <img v-if="partner === WhiteLabelPartnerEnum.BAYZAT" src="../../assets/logos/bayzat-wc.png" class="h-20" alt="bayzat ats logo">
      <img v-else src="../../assets/logos/wc-logo.png" class="h-20" alt="whitecarrot ats logo">
    </div>
    <!-- eslint-disable vue/no-v-text-v-html-on-component -->
    <WcTypography v-html="text" color="#5138EE" class="company-title" title=""/>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { WhiteLabelPartnerEnum } from '@/views/dashboard/dashboard-model'
import WcTypography from '@/components/UILibrary/Typography/WcTypography.vue'

@Component({
  name: 'company-logo',
  components: { WcTypography },
  computed: {
    WhiteLabelPartnerEnum() {
      return WhiteLabelPartnerEnum
    }
  }
})
export default class extends Vue {
  @Prop({ default: '' }) private partner!: WhiteLabelPartnerEnum
  @Prop({ default: '' }) private text!: string
  @Prop({ default: false }) private isExtension!: boolean
}
</script>
<style>
.company-title{
  @media (min-width: 640px) {
    font-size: 1.25rem !important;
    line-height: 1.75rem !important;
  }
  @media (min-width: 768px) {
    font-size: 1.375rem !important;
    line-height: 2rem !important;
  }
}
</style>
